import { _select, lm } from '../../listenerMiddleware';
import { getCreativeFolder } from '../breadcrumbs/selectors';
import { updateWorkflow } from '../creativeWorkflow';
import { getEligibleNodes } from './selectors';
import * as linkExistingFilesActions from './actions';

export function linkExistingFilesRootListener() {
  lm.takeEvery(linkExistingFilesActions.triggerButtonClicked, async (_action, lapi) => {
    const creativeFolder = _select(lapi, getCreativeFolder);
    const eligibleNodes = _select(lapi, getEligibleNodes);

    if (!creativeFolder || eligibleNodes.length === 0) {
      return;
    }

    await updateWorkflow(lapi, eligibleNodes, creativeFolder.id, {
      successTitle: 'Creative file changes have been applied successfully',
      errorTitle: 'Creative file update error',
      errorMessage: (failedCount) => `Failed to apply changes to ${failedCount} file(s)`,
    });
  });
}
